import React, { useState } from 'react';
import { StatOptions } from 'fs';
import { RiderModel, ActionType, RiderStatusType, User, RiderPackageModel, BranchModel, CustomerAddressModel, VehicleDataModel, ManufacturerModel, VehicleModelModel, Riders_PackagesModel, CustomerContactDetailsModel } from '../../models/superbit-api-models'
import { SubscribersModel } from '../../models/SubscribersModel'
import '../../assets/css/_new-subscriber-popup.css';

import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../../models/Site'
import { SimulatorModel, SimulatorData } from '../../models/SimulatorModel'
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DynamicSelect } from '../../components/_DynamicSelect'
import VehicleData from "../../vehicles/_Vehicle";
import BranchesStationsTree from "../../Branches/_branchesStationsTree"
// import 'react-dropdown-tree-select/dist/styles.css'


type Props = {
    id: string | undefined;
    actionType: ActionType | undefined;
    ClosePopup: any;
    rider?: RiderModel | undefined | null;
    setPopupShow: React.Dispatch<React.SetStateAction<boolean>>;
    setMessege: React.Dispatch<React.SetStateAction<string>>;
};
type State = {
    data: RiderModel | null;
    Gender: IDNameDescriptionDictionary;
    IdentityTypes: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    AuthorizedToDriveItems: IDNameDescriptionDictionary;
    InsuranceTypes: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    CustomerAgents: IDNameDescriptionDictionary;
    CustomerHandlers: IDNameDescriptionDictionary;
    SubscriptionStatuses: IDNameDescriptionDictionary;
    Branches: IDNameDescriptionDictionary;
    CarYear: Array<string>;
    SelectedTab: number;
    RiderStatusType: Array<RiderStatusType>;
    licenseNumber: string;
    editMode: boolean;
    packagesList: IDNameDescriptionDictionary;
    vehicles: Array<VehicleDataModel> | null;
    vehicleValidationHandler: string;
    handlerErrMsg: string;
    startDateErrMsg: string;
    endDateErrMsg: string;
    showPackages: boolean;
    saveLoading: boolean;
};
// AuthorizedToDriveItems


export class SubscriberUpdateEndDatePopup extends React.Component<Props> {

    private birthDateRef: React.RefObject<DatePicker>;
    private subscriptionStartDateRef: React.RefObject<DatePicker>;
    private subscriptionEndDateRef: React.RefObject<DatePicker>;
    simulatorModel: SimulatorModel;

    state: State = {
        data: null,
        Gender: new IDNameDescriptionDictionary(),
        IdentityTypes: new IDNameDescriptionDictionary(),
        VehicleOwnership: new IDNameDescriptionDictionary(),
        AuthorizedToDriveItems: new IDNameDescriptionDictionary(),
        InsuranceTypes: new IDNameDescriptionDictionary(),
        MaritalStatus: new IDNameDescriptionDictionary(),
        CustomerAgents: new IDNameDescriptionDictionary(),
        CustomerHandlers: new IDNameDescriptionDictionary(),
        SubscriptionStatuses: new IDNameDescriptionDictionary(),
        Branches: new IDNameDescriptionDictionary(),
        CarYear: [],
        SelectedTab: 1,
        RiderStatusType: [],
        licenseNumber: '',
        editMode: false,
        packagesList: new IDNameDescriptionDictionary(),
        vehicles: null,
        vehicleValidationHandler: "",
        handlerErrMsg: "",
        startDateErrMsg: "",
        endDateErrMsg: "",
        showPackages: false,
        saveLoading: false
    };

    constructor(props: any) {
        super(props);
        this.birthDateRef = React.createRef<DatePicker>();
        this.subscriptionStartDateRef = React.createRef<DatePicker>();
        this.subscriptionEndDateRef = React.createRef<DatePicker>();
        this.simulatorModel = new SimulatorModel();
    }

    updateStationUser = (stationId: string) => {

        var data = this.state.data;
        if (data) {
            data.stationUserId = stationId;
        }
        this.setState({ data: data });

    }
    updateBranch = (vehicle: VehicleDataModel) => {

    }

    closePopup = () => {
        this.props.ClosePopup();
        console.log('closePopup')
    }

    save = async () => {
        if (this.state && this.state.data
            && this.state.data.customer
            && this.state.data.vehicle
            && this.state.data.vehicle.manufacturer
            && this.state.data.vehicle.vehicleSubModel
        ) {
            const newRidierData: any = {
                "Customer": {
                    "Id": this.state.data.customer.id,
                    "Handler": {
                    },
                    "Agent": {
                    },
                    "IdentityType": this.state.data.customer.identityType,
                    "Identifier": this.state.data.customer.identifier,
                    "FirstName": this.state.data.customer.firstName,
                    "LastName": this.state.data.customer.lastName,
                    "FullName": this.state.data.customer.firstName + ' ' + this.state.data.customer.lastName,
                    "DateOfBirth": this.state.data.customer.dateOfBirth,
                    "Gender": this.state.data.customer.gender,
                    "CustomerAddresses": this.state.data.customer.customerAddresses,
                    "CustomerContactDetails": this.state.data.customer.customerContactDetails
                },
                "Vehicle": {
                    "LicenseNumber": this.state.licenseNumber,
                    "ModelCode": this.state.data.vehicle.modelCode,
                    "CarYear": this.state.data.vehicle.carYear,
                    "Manufacturer": {
                        "Id": this.state.data.vehicle.manufacturer.id
                    },
                    "VehicleSubModel": {
                        "Id": this.state.data.vehicle.vehicleSubModel.id
                    },
                    "VehicleSubModelId": this.state.data.vehicle.vehicleSubModelId
                }
            }
            console.log(newRidierData, this.state.data.customer);
            const response = await new SubscribersModel().riderUpdateDetails(newRidierData);
            if (!response) {
                this.closePopup();
            }
        }
        console.log(this.state.data);
    }

    changeCurrentTab = (num: number) => {
        let currentTab = this.state.SelectedTab;
        currentTab += num;
        this.setState({
            SelectedTab: currentTab
        });
    }

    componentDidMount() {
        this.load();
    }

    handleChange(e: any) { }

    isAdmin() {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0 
        }
        return false;
    }


    async load() {
        // 
        var CarYear = [];
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            CarYear.push(i + "");
        }
        if (this.props.id && this.props.id != '') {
            this.setState({
                editMode: true
            })
        }
        // const model = this.props.rider ? this.props.rider : new RiderModel();// await new SubscribersModel().upsertRider(this.props.id,this.props.actionType);
        const model = await new SubscribersModel().upsertRider({
            id: this.props.id,
            actionType: this.props.actionType
        });
        // console.log('model', model);
        // console.log('rider', this.props.rider);
        // 
        let licenseNumber = '';
        if (model.vehicle && model.vehicle.licenseNumber) {
            licenseNumber = model.vehicle.licenseNumber;
        }
        let statusPop=[];
if(this.isAdmin()){
    statusPop =[
        {
            description: 'פעיל',
            name: 'פעיל',
            id: 0
        },
        {
            description: 'מוקפא',
            name: 'מוקפא',
            id: 1
        },
        {
            description: 'ביטול',
            name: 'ביטול',
            id: 2
        }
    ];
}
else{
    statusPop =[
        {
            description: 'פעיל',
            name: 'פעיל',
            id: 0
        },
        {
            description: 'מוקפא',
            name: 'מוקפא',
            id: 1
        }
    ];
}

        this.setState({
            data: model,
            Gender: await this.simulatorModel.getGenderTypes(),
            IdentityTypes: await this.simulatorModel.getIdentityTypes(),
            VehicleOwnership: await this.simulatorModel.getVehicleOwnership(),
            AuthorizedToDriveItems: await this.simulatorModel.getAuthorizedToDriveItems(),
            InsuranceTypes: await this.simulatorModel.getInsuranceTypes(),
            MaritalStatus: await this.simulatorModel.getMaritalStatus(),
            CarYear: CarYear,
            SelectedTab: 1,
            RiderStatusType: [],
            CustomerHandlers: await this.normalizeHandlers(),
            CustomerAgents: await this.normalizeAgents(),
            Branches: await this.buildTreeSelectData(),
            selectedBranch: null,
            licenseNumber: licenseNumber,
            SubscriptionStatuses: statusPop,
            packagesList: this.buildPackagesList(model.packages),
            vehicles: model.customer.vehicles
        });

        console.log('Edit', this.state)
    }

    async getBranchesTree() {
        const branchesTree: any = []; // barnc
        const allBranches = await this.simulatorModel.getBranches();
        // // const branches = [];
        const rootBranches = allBranches ? allBranches.filter((b: any) => b.parentId === null) : [];
        const childBranches = allBranches ? allBranches.filter((b: any) => b.parentId !== null) : [];


        childBranches.forEach((branch: any) => {
            const rootBranch = rootBranches.find((b: any) => b.id === branch.parentId);
            if (rootBranch) {
                if (rootBranch.children) {
                    rootBranch.children.push(branch);
                } else {
                    rootBranch.children = [branch];
                }
            } else {
                branch.notInTree = true
            }
            // console.log('rootBranches child', rootBranch)
        });

        while (allBranches.filter((b: any) => b.parentId !== null).length > 0) {
            this.arangeBranchesIntoTree(allBranches);
        }
        console.log('arangeBranchesIntoTree', allBranches);

        return branchesTree;
    }

    arangeBranchesIntoTree = (bList: any[]) => {
        bList.forEach((branch: any, index: number) => {
            if (branch.parentId !== null) {
                const parentItem = bList.find((i: any) => i && i.id && i.id === branch.parentId);
                if (parentItem) {
                    const child = JSON.parse(JSON.stringify(branch));
                    if (parentItem.children) {
                        parentItem.children.push(child);
                    } else {
                        parentItem.children = [child];
                    }
                }
                delete bList[index];
            }
        })
    }

    getTreeItem = (branch: any, isParent = true) => {
        if (branch.children) {
            isParent = true;
        }
        const item = {
            label: branch.name,
            value: branch.id,
            isParent: isParent ? true : false,
            // disabled: isParent ? true : false,
            className: 'hidden-checkbox',
            children: []
        }
        if (branch.children && branch.children.length > 0) {
            branch.children.forEach((c: any) => {
                const newItem = this.getTreeItem(c);
                item.children.push(newItem as never);
            })
        }
        return item;
    }

    onBranchChange = (e: any) => {
        const branches = this.state.Branches as any;
        if (e.checked && !e.isParent) {
            this.setState({
                selectedBranch: e.value
            });
        } else {
            this.setState({
                selectedBranch: null
            });
        }

        branches.forEach((branch: any) => {
            branch.checked = false;
            if (branch.children) {
                branch.children.forEach((child: any) => {
                    if (child.value === e.value && e.checked) {
                        child.checked = true;
                    } else {
                        child.checked = false
                    }
                });
            }
        });

        this.setState({
            Branches: branches
        })
        console.log('onBranchChange', e)
    }

    onBranchToggle = (e: any) => {
        // console.log('onBranchToggle', e);
    }


    buildTreeSelectData = async () => {
        const allBranches = await this.simulatorModel.getBranches();
        const rootItems = allBranches.filter((b: any) => b.parentId === null);
        const subBranches = allBranches.filter((b: any) => b.parentId != null);
        const branchesTree: any = [];
        rootItems.forEach((bItem: any) => {
            const branch = this.buildBranchData(bItem.id, allBranches);
            branchesTree.push(branch);
        });

        // this.setState({
        //     Branches: branchesTree
        // });
        console.log('branchesTree', subBranches, branchesTree);
        return branchesTree;
    }

    buildBranchData = (branchId: string | null, allBranches: any[]) => {
        const branchData = allBranches.find((b: any) => b.id === branchId);
        const branch: any = {
            label: branchData.name,
            value: branchData.id,
            tagClassName: ''
        }
        const subBranches: any[] = [];
        const items = allBranches.filter((b: any) => b.parentId === branchId);
        items.forEach((item: any) => {
            const branchSub = this.buildBranchData(item.id, allBranches);
            subBranches.push(branchSub);
        });
        branch.children = subBranches;
        if (branchData.users && branchData.users.length > 0) {
            branchData.users.forEach((user: any) => {
                branch.children.push({
                    value: user.value,
                    label: user.text
                })
            })
        }
        return branch;
    }

    onTreeSelectChange = (currentNode: any, selectedNodes: any[]) => {
        console.log(currentNode, selectedNodes);
    }

    async normalizeHandlers() {
        const customerCardHandlers = await this.simulatorModel.getCustomerCardHandlers();
        const returnDictionary: any = {}
        customerCardHandlers.map((c: User, key: number) => {
            const item: any = {};
            item.description = c.fullName;
            item.name = c.fullName;
            item.id = c.id;
            returnDictionary[key] = item;
        });
        return returnDictionary;
    }

    async normalizeAgents() {
        const customerCardHandlers = await this.simulatorModel.getCustomerCardAgents();
        return customerCardHandlers.map((a: any) => {
            return {
                description: a.name,
                name: a.name,
                id: a.id
            }
        }) as IDNameDescriptionItem[];
    }

    buildPackagesList = (packages: any) => {
        const newList: any = [{
            description: 'בחר',
            name: '',
            id: 0,
            package: null
        }];
        packages.forEach((p: any) => {
            newList.push({
                description: p.name,
                name: p.name,
                id: p.id
            })
        });
        console.log('buildPackagesList', newList)
        return newList as IDNameDescriptionDictionary;
    }

    async normalizeBranches() {
        const branchesList = await this.simulatorModel.getBranches();
        // return customerCardHandlers.map((a: any) => {
        //     return {
        //         description: a.name,
        //         name: a.name,
        //         id: a.id
        //     }
        // }) as IDNameDescriptionItem[];
    }

    changeStatus = (name: string, value: any) => {
        this.setStateData(name, value);

        if (value == "2") {
            this.setState({ showPackages: true });
        }
        else {
            this.setState({ showPackages: false });
        }
    }

    setStateData = (name: string, value: any) => {
        let stateData = this.state.data;
        if (!stateData) {
            stateData = new RiderModel();
        }
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            stateData.customer.customerAddresses.push(address);
        }
        if (stateData.customer) {
            if (!stateData.customer.customerContactDetails) {
                stateData.customer.customerContactDetails = [];
            }
            if (stateData.customer.customerContactDetails.length == 0) {
                const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                    id: '',
                    emailAddress: '',
                    number: ''
                })
                stateData.customer.customerContactDetails.push(customerContactDetail);
            }
        }
        switch (name) {
            // customer
            case 'identifier': {
                if (stateData && stateData.customer) {
                    stateData.customer.identifier = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'firstName': {
                if (stateData && stateData.customer) {
                    stateData.customer.firstName = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'lastName': {
                if (stateData && stateData.customer) {
                    stateData.customer.lastName = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'dateOfBirth': {
                if (stateData && stateData.customer) {
                    stateData.customer.dateOfBirth = value as Date;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'gender': {
                if (stateData && stateData.customer) {
                    stateData.customer.gender = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'telNumber': {
                if (stateData.customer) {
                    if (!stateData.customer.customerContactDetails) {
                        stateData.customer.customerContactDetails = [];
                    }
                    if (stateData.customer.customerContactDetails.length == 0) {
                        const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                            id: '',
                            emailAddress: '',
                            number: ''
                        })
                        stateData.customer.customerContactDetails.push(customerContactDetail);
                    }
                    stateData.customer.customerContactDetails[0].number = value;
                }

                break;
            }
            case 'emailAddress': {
                if (stateData && stateData.customer && stateData.customer.customerContactDetails && stateData.customer.customerContactDetails.length > 0) {
                    stateData.customer.customerContactDetails[0].emailAddress = value;
                }
                break;
            }
            // customer address
            case 'city': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].city = value;
                }
                break;
            }
            case 'street': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].street = value;
                }
                break;
            }
            case 'houseNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].houseNumber = value;
                }
                break;
            }
            case 'apartmentNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].apartmentNumber = value;
                }
                break;
            }
            case 'postalCode': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].postalCode = value;
                }
                break;
            }
            case 'mailbox': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].mailbox = value;
                }
                break;
            }
            // vehicle
            case 'licenseNumber': {
                if (stateData && stateData.vehicle && stateData.vehicle.licenseNumber) {
                    stateData.vehicle.licenseNumber = value;
                }

                break;
            }
            default:
                (stateData as any)[name] = value
                break;
        }
        this.setState({ data: stateData });
    }

    saveRider = async () => {
        // 
        if (this.state && this.state.data) {
            this.setState({ saveLoading: true });

            console.log(this.state.data, this.state.data.customer);

            var data = this.state.data;
            data.createdDate = new Date();
            data.agents = undefined;
            data.branches = undefined;
            data.packages = undefined;
            data.salesPeople = undefined;
            data.users = undefined;

            const response = await new SubscribersModel().RiderFixEndDate(data);
            // 
            if (response && response.responseCode == 200) {
                // 
                //open payment popup
                this.closePopup();
                this.props.setPopupShow(true);
                this.props.setMessege("עודכן תאריך סיום מנוי בהצלחה");
            }
            else {
                this.setState({ createRiderErr: response.responseMessage });

            }
            this.setState({ saveLoading: false });


        }
    }


    getVehicleDetailsKeyPress = async (event: any) => {
        console.log(event.key);
        if (event.key === 'Enter' || event.key === 'Tab') {
            const licenseNumber = event.currentTarget.value;
            this.getVehicleDetails(licenseNumber);
            this.setStateData('licenseNumber', licenseNumber)
        } else {
            // this.setState({licenseNumber: event.target.value});
        }
    }

    getVehicleDetails = async (licenseNumber: string) => {
        var data = await this.simulatorModel.getVehicleDetailsByLicenseNumber(licenseNumber);

        console.log('getVehicleDetailsByLicenseNumber', data);
        let riderData = this.state.data;
        if (!riderData) {
            riderData = new RiderModel();
        }
        if (!riderData.vehicle) {
            riderData.vehicle = new VehicleDataModel();
        }

        console.log(riderData.vehicle);


        if (data && data.LeviItzhak != null) {
            if (data.LeviItzhak.manufacturer != null) {
                if (!riderData.vehicle.manufacturer) {
                    riderData.vehicle.manufacturer = new ManufacturerModel();
                }
                riderData.vehicle.manufacturer.name = data.LeviItzhak.manufacturer.label;
                riderData.vehicle.manufacturer.id = data.LeviItzhak.manufacturer.val;

            }
            if (data.LeviItzhak.vehicleModel != null) {
                if (!riderData.vehicle.vehicleModel) {
                    riderData.vehicle.vehicleModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleModel.name = data.LeviItzhak.vehicleModel.label;
                riderData.vehicle.vehicleModel.id = data.LeviItzhak.vehicleModel.val;
            }
            if (data.LeviItzhak.vehicleSubModel != null) {
                if (!riderData.vehicle.vehicleSubModel) {
                    riderData.vehicle.vehicleSubModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                riderData.vehicle.vehicleSubModel.name = data.LeviItzhak.vehicleSubModel.label;
                riderData.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
            }

            riderData.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
            riderData.vehicle.carYear = data.LeviItzhak.carYear;
            riderData.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;
        }
        this.setState({
            data: riderData
        })
    }

    onSelectPackage(name: string, value: any) {
        console.log(name, value);
        const riderData = this.state.data;
        if (riderData && riderData.packages) {
            const selectedPackage = riderData.packages.find((p: any) => p.id === value);
            if (selectedPackage) {
                console.log('selectedPackage', selectedPackage);
                this.addRiderPackage(selectedPackage);
            }
        }
    }

    startDateValidation() {
        var data = this.state.data;
        if (data) {
            if (data.startDate == undefined || data.startDate == null) {
                this.setState({ startDateErrMsg: "* חובה" });
                return false;
            } else {

                if (data.startDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                    this.setState({ startDateErrMsg: "תאריך תחילה לא חוקי" });
                    return false;
                }
                this.setState({ startDateErrMsg: "" });
                return true;
            }

        }
        return true;
    }

    endDateValidation() {
        var data = this.state.data;
        if (data) {
            if (data.endDate == undefined || data.endDate == null) {
                this.setState({ endDateErrMsg: "* חובה" });
                return false;
            }
            if (data.startDate && data.startDate > data.endDate) {
                this.setState({ endDateErrMsg: "תאריך סיום לא חוקי" });
                return false;
            }
            this.setState({ endDateErrMsg: "" });
            return true;
        }
        return true;
    }

    addRiderPackage = (selectedPackage: any) => {
        const data = this.state.data ? this.state.data : new RiderModel();
        if (!data.riderPackages) {
            data.riderPackages = [];
        }

        const newRiderPackage = new Riders_PackagesModel();
        newRiderPackage.riderId = data.id;
        newRiderPackage.riderPackageId = selectedPackage.id;
        newRiderPackage.riderPackage = selectedPackage;
        newRiderPackage.agentCost = selectedPackage.agentCost;
        newRiderPackage.customerCost = selectedPackage.recommendedCost;

        data.riderPackages.push(newRiderPackage);

        this.setState({ data: data });
    }

    removeRiderPackage = (packageId: string) => {
        console.log('packageId to remove:', packageId);
        const data = this.state.data ? this.state.data : new RiderModel();
        if (data.riderPackages) {
            const selectedPackageIndex = data.riderPackages.findIndex((p: any) => p && p.riderPackageId === packageId);
            if (selectedPackageIndex) {
                // console.log('package to remove:', selectedPackage);
                delete data.riderPackages[selectedPackageIndex];
                this.setState({
                    data: data
                });
            }
        }
    }

    updateVehicle = (vehicle: VehicleDataModel) => {
        var data = this.state.data;
        if (data) {
            data.vehicle = vehicle;
        }
        this.setState({ data: data });

    }

    VehicleValidation = (isValid: boolean) => {


    }

    checkUsedRider = (item: any, e: any) => {

        //usedPackagesForCencelRider
        var data = this.state.data;
        var id = item.item.riderPackage.id;
        if (data) {
            if (!data.usedPackagesForCencelRider) {
                data.usedPackagesForCencelRider = [];
            }
            if (e.target.checked) {

                if (!data.usedPackagesForCencelRider.includes(id)) {
                    data.usedPackagesForCencelRider.push(id);
                }

            }
            else {
                data.usedPackagesForCencelRider = data.usedPackagesForCencelRider.filter((existingItem) => existingItem !== id);
            }
            this.setState({ data: data });
        }
    }



    render() {
        return (<>
            {this.state.data != null ? (
                <>

                    <div className="popup-wrapper">
                        <section className="popup-window new-subscriber rtl">
                            <div className="close-icon pointer" onClick={(e: any) => this.closePopup()}></div>
                            <div className="popup-content">
                                <div className="popup-header">
                                    <div className="popup-title">
                                        פרטי מנוי
                                    </div>
                                </div>
                                <div className='popup-body'>
                                    <div className={'tab-content tab-content-2 ' + (this.state.SelectedTab === 2 ? 'selected' : '')}>
                                        <div className="parameter-row">
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        מס' מנוי
                                                    </div>
                                                    <div className="value">
                                                    {this.state.data.subscriberNumber!=null ? this.state.data.subscriberNumber : ""}
                                                    {this.state.data.additionNumber != null ?"/"+ (this.state.data.additionNumber>10?this.state.data.additionNumber:"0"+this.state.data.additionNumber) : ""}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        תאריך סיום
                                                    </div>
                                                    <div className="value">
                                                        <DatePicker
                                                            ref={this.subscriptionEndDateRef}
                                                            selected={
                                                                this.state.data != null &&
                                                                    this.state.data.startDate != null ? this.state.data.endDate : null}
                                                            onSelect={(e: any) => this.setStateData("endDate", e)}
                                                            onChange={(e: any) => this.setStateData("endDate", e)}
                                                            dateFormat='dd/MM/yyyy'
                                                        /> 

                                                        
                                                        <div className="icon small-icon calendar pointer"></div>
                                                    </div>
                                                    <div className='error-message2'>{this.state.endDateErrMsg}</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                 
                                </div>

                                <div className="popup-footer">
                                    {this.state.SelectedTab > 1 && (
                                        <button className="button blue prev-button" onClick={(e: any) => this.changeCurrentTab(-1)} >
                                            &lt;&lt; הקודם
                                        </button>
                                    )}
                                    <button className="button white blue-border" onClick={(e: any) => this.closePopup()}>
                                        ביטול
                                    </button>

                                    <button className="button white blue-border" onClick={(e: any) => this.saveRider()} disabled={this.state.saveLoading ? true : false}>
                                        שמור
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>







                </>
            ) : ""}
        </>



        );
    }
}
